import AbstractPeriodColumnSource from "./AbstractPeriodColumnSource.js";

/**
 * This class is used when a period column should fetch data from a
 * budget.
 *
 * @param {string} budgetId - A unique identifier for the budget being
 *   used as source of data for the period column
 */
export default class BudgetPeriodColumnSource extends AbstractPeriodColumnSource {
	constructor({ budgetId }) {
		super(...arguments);

		this._budgetId = budgetId;
	}

	getBudgetId() {
		return this._budgetId;
	}

	isBudgetSource() {
		return true;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.budgetId = this._budgetId;

		return properties;
	}
}
